module.exports = __webpack_public_path__ + "static/media/M1-9-Zakan-O-Gladiador-cod108.3ebcfaa7.png";